import styled from 'styled-components';

export const StyledSave = styled.span`
  cursor: pointer;
`

export const StyledEdit = styled.span`
  cursor: pointer;
`